import React from 'react';
import {HomeGameCardItem} from '../home.type';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
// import LazyImage from '@/components/basic/image';
import theme from '@/style';
import {Image} from 'antd-mobile';
import {getGamePicUrl, GamePicType} from '@/components/utils/utils';
// import {Dimensions} from 'react-native';

interface GameCardProps {
  item: HomeGameCardItem;
  screenWidth: number;
  screenHeight: number;
  onPress?: (item: HomeGameCardItem) => void;
}

export const GameCard2: React.FC<GameCardProps> = ({
  item,
  screenWidth,
  screenHeight,
  onPress,
}) => {
  return (
    <NativeTouchableOpacity
      onPress={() => onPress && onPress(item)}
      style={[
        theme.borderRadius.m,
        theme.overflow.hidden,
        {
          width: screenWidth,
          height: screenHeight,
          //   flex: 'none',
          backgroundColor:
            item.categoryId === -9999
              ? 'transparent'
              : theme.backgroundColor.palegrey,
        },
      ]}>
      <Image
        src={getGamePicUrl(
          GamePicType.V_RECTANGLE,
          item.source,
          item.tripartiteUniqueness,
        )}
        width={'100%'}
        height={'100%'}
        fallback={<div className="size-full bg-image" />}
        // resizeMode="cover"
      />
    </NativeTouchableOpacity>
  );
};
